import type { PageEventHandler } from '@/play/pageTypes'
import { applyFoldResult, foldInk, isFoldParams, type FoldParams } from './fold'

/** Fold the paper along a crease and unfold it: ink prints mirrored onto the other half (./fold.ts). */
export const SQUISH_FOLD_EVENT = 'experience.squish.fold' as const

export function squishFoldEvent(params: FoldParams): readonly [typeof SQUISH_FOLD_EVENT, FoldParams] {
  return [SQUISH_FOLD_EVENT, { axis: params.axis, hinge: params.hinge, paperTop: params.paperTop, foldIndex: params.foldIndex }]
}

/** Reducer handlers for the Squish world (`experience.squish.*`). */
export const eventHandlers: Record<string, PageEventHandler> = {
  [SQUISH_FOLD_EVENT]: (ctx, event) => {
    const payload = event[1]
    if (!isFoldParams(payload)) return
    applyFoldResult(ctx.base, foldInk(ctx.base, ctx.meta.bounds, payload))
  },
}

/** The same handlers under the page's earlier name (tests). */
export const squishEventHandlers = eventHandlers
